export const getStatusTextClass = (status: string) => {
  switch (status.toLowerCase()) {
    case 'valid':
      return 'text-green-600 font-medium';
    case 'expired':
      return 'text-red-500 font-medium';
    case 'used':
      return 'text-blue-600 font-medium';
    default:
      return 'text-red-600 font-medium'; 
  }
};
